import React from 'react'

import * as style from './style.module.scss'

const Burger = ({ active, onClick }) => {
    const burgerClass = [style.hamburger]

    if (active) {
        burgerClass.push(style.is_active)
    }

    return (
        <button
            className={burgerClass.join(' ')}
            onClick={e => onClick(e)}
            type="button"
        >
            <span className={style.hamburger_box}>
                <span className={style.hamburger_inner}>
                    <span className={style.hamburger_accessible}>Open Menu</span>
                </span>
            </span>
        </button>
    )
}

export default Burger
